import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

import { IClientContactPerson } from "../../models/ClientContactPerson";
import { IDesignationMastDropdown } from "../../models/IDropdown";

import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { IClientCompanyDropdown } from "../../models/IDropdown";
import { JVInputCheck } from "../../shared/JVInputCheck";
import { Messages } from "primereact/messages";
import { EmptyClientContactPerson } from "../clientContactPerson/EmptyClientContactPerson";
import { JVInputMask } from "../../shared/JVInputMask";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { ILogin } from "../../models/Login";

const schema = yup.object({
    contact_Person_EmailID: yup.string().required("EmailID is required*").email(),
    vendor_Company: yup.object().shape({
        vendor_Company_ID: yup.number().min(1, "Client Company Name is required*").required("Client Company Name is required*"),
        vendor_Company_Name: yup.string().required(),
        website_URL: yup.string()
    }).typeError("Client Company Name is required"),
    contact_Person_Name: yup.string().required("Name is required*").min(3),
    designation: yup.number().min(1, "Designation is required*").required("Designation is required*"),
    phone_No: yup.string().required("Phone No is required*"),
    ext: yup.string().nullable(),
    cell_No: yup.string().nullable(),
    major_Technology: yup.string().nullable()
});

const emailSchema = yup.object().shape({
    email: yup.string().required().email()
});

interface IVCompanyInfo {
    vendor_Company_ID?: number,
    noofReq?: number,
    noOfServe?: number,
    noOfResume?: number,
    noOfECI?: number,
    noOfPO?: number,
    noOfPOFiz?: number,
    noOfPOEnded?: number,
    noOfPOJoined?: number
}

interface Iprops {
    singleData: IClientContactPerson,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    onSuccess: () => void
}

export const ClientContact = (props: Iprops) => {
    const message = useRef<any>(null);
    const [designations, setDesignations] = useState<Array<IDesignationMastDropdown>>();
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [vCompanyInfo, setVCompanyInfo] = useState<IVCompanyInfo>();
    const [emailPatterns, setEmailPatterns] = useState<Array<string>>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IClientContactPerson>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach((role: { role_ID: number; }) => {
        _roles.push(role.role_ID);
    });

    const loadVCompanyInfo = async (vendor_company_id: number) => {
        const responseI = await Fetch(`Vendor_Company_Mast/statusCount`, "GET", null, `vendor_company_id=${vendor_company_id}`, null);
        if (responseI) {
            const data: IVCompanyInfo = await responseI.json();
            setVCompanyInfo(data);
        }
    }

    const loadEmailPatterns = async (vendorCompanyId: number) => {
        const response = await Fetch("name_email_patterns", "GET", null, `vendorCompanyId=${vendorCompanyId}`, null);
        if (response) {
            const data: Array<string> = await response.json();
            setEmailPatterns(data);
        }
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "vendor_Company") {
                if (value.vendor_Company?.vendor_Company_ID) {
                    loadEmailPatterns(value.vendor_Company.vendor_Company_ID);
                    loadVCompanyInfo(value.vendor_Company.vendor_Company_ID);
                }
                else setVCompanyInfo(undefined);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const checkEmail = async () => {
        const valid = await emailSchema.isValid({
            email: control._formValues.contact_Person_EmailID,
        });
        if (valid) {
            setLoading(true);
            const response = await Fetch("Sub_Vendor_Contact_Person_Mast/searchEmail", "GET", null, `filter=${control._formValues.contact_Person_EmailID}`, props.toast);
            response && message.current.show({ severity: 'success', content: "Email Available." });
            setLoading(false);
        } else {
            message.current.show({ severity: 'error', content: "Please Enter a Valid Email" });
        }
    }

    const loadDesignations = async () => {
        const response = await Fetch("Dropdown/designation", "GET", null, null, null);
        if (response) {
            const data: Array<IDesignationMastDropdown> = await response.json();
            setDesignations(data);
        }
    }
    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }

    useEffect(() => {
        loadClientCompanies(null);
        loadDesignations();
    }, [props.open]);

    const completeMethod = (event: { query: string }) => {
        setEmailPatterns([]);
        loadClientCompanies(event.query);
    }

    const saveToDB = async (body: IClientContactPerson) => {
        setLoading(true);
        const method = "POST";
        const message = "Client Added Successfully, Waiting for Reuirement to Autofill.";

        body.vendor_Company_ID = body.vendor_Company?.vendor_Company_ID;
        delete body.vendor_Company;

        const response = await Fetch("Sub_Vendor_Contact_Person_Mast", method, body, null, props.toast);
        if (response) {
            onHide();
            props.onSuccess();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
        }
        setLoading(false);
    }

    const onHide = () => {
        props.hideDialog();
        setEmailPatterns([]);
        reset(EmptyClientContactPerson);
        setVCompanyInfo(undefined);
    }

    function onSubmit(data: IClientContactPerson) {
        const e_domain = data.contact_Person_EmailID?.split("@")[1];
        if (!(e_domain?.includes("gmail") || e_domain?.includes("outlook")
            || e_domain?.includes("protonmail") || e_domain?.includes("aol")
            || e_domain?.includes("yahoo") || e_domain?.includes("hotmail")
            || e_domain?.includes("rediff"))) {
            saveToDB(data);
        }
        else props.toast.current.show({ severity: 'error', detail: "Contact Person Email can't be any of public domains like Google,Yahoo,Outlook,hotmail,rediff etc.", life: 3000 });
    }

    const header = () => {
        return <>
            <h4>Add Client Contact Person</h4>
            <h6 className="text-yellow-600">{`Client "${props.singleData.contact_Person_EmailID}" is not in system, please add first to post a requirement.`}</h6>
        </>
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={header} modal className="p-fluid" onHide={onHide}>
            {vCompanyInfo && <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                value={[vCompanyInfo]}
            >
                <Column field="noofReq" header="Req#" />
                <Column field="noOfServe" header="Serv#" />
                <Column field="noOfResume" header="Sub#" />
                <Column field="noOfECI" header="ECI#" />
                <Column field="noOfPO" header="PO#" />
                <Column field="noOfPOFiz" header="POF#" />
                <Column field="noOfPOEnded" header="POE#" />
                <Column field="noOfPOJoined" header="POJ#" />
            </DataTable>}
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <div className="field col-12 md:col-12">
                    <Messages ref={message} />
                </div>
                <JVInputCheck disabled required func={checkEmail} label="Email ID" control={control} name="contact_Person_EmailID" error={errors.contact_Person_EmailID?.message} />

                <JVDropdownInput required completeMethod={completeMethod} label="Client Company Name" control={control} name="vendor_Company" error={errors.vendor_Company?.message} options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Client Company" />

                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <p>Email Patterns: {emailPatterns.length > 0 && <span className="text-purple-500 font-bold">{emailPatterns.join("  |  ")}</span>}</p>
                </div>

                <JVInput required label="Name" control={control} name="contact_Person_Name" error={errors.contact_Person_Name?.message} />
                <JVDropdown required label="Designation" control={control} name="designation" error={errors.designation?.message} options={designations} optionLabel="designation_Name" optionValue="designationId" placeholder="Select Designation" />
                <JVInputMask mask="(999) 999-9999" required label="Phone No" control={control} name="phone_No" error={errors.phone_No?.message} />
                <JVInput label="Ext." control={control} name="ext" error={errors.ext?.message} />
                <JVInput label="Cell No" control={control} name="cell_No" error={errors.cell_No?.message} />
                <JVInput label="Major Technology" control={control} name="major_Technology" error={errors.major_Technology?.message} />
                {(_roles.includes(1) || _roles.includes(26)) && <JVCheckbox column={4} control={control} name="disable_Share_PV" label="Disable Share PV" />}

                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} loading={loading} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                </div>

            </form>
        </Dialog>
    );
}